import React from "react";
import Header from "../../components/VibrantSolComponents/Header";
import Footer from "../../components/VibrantSolComponents/Footer";
import blogimage from "../../blog-image1.png";
import blogimage1 from "../../blog-image2.png";
import blogimage2 from "../../blog-image3.png";
import blogimage3 from "../../blog-image4.png";
const blogs = [
  {
    id: 1,
    image: blogimage, // replace with your img src
    date: "November 02, 2022",
    title: "Night Cream Vs Moisturiser Vs Serum - Which Is Best For Your Skin?",
    excerpt:
      "Ever wondered what the right skincare product for your skin is? From night creams and...",
    link: "/blogdetails",
  },
  {
    id: 2,
    image: blogimage1, // replace with your img src
    date: "November 01, 2022",
    title: "Why Do You Sweat After A Shower And How Can You Stop It?",
    excerpt:
      "Do you end up sweating right after a long, refreshing shower? While this seems counter-productive...",
    link: "/blogdetails",
  },
  {
    id: 3,
    image: blogimage2, // replace with your img src
    date: "November 02, 2022",
    title: "Night Cream Vs Moisturiser Vs Serum - Which Is Best For Your Skin?",
    excerpt:
      "Ever wondered what the right skincare product for your skin is? From night creams and...",
    link: "/blogdetails",
  },
  {
    id: 4,
    image: blogimage3, // replace with your img src
    date: "November 01, 2022",
    title: "Why Do You Sweat After A Shower And How Can You Stop It?",
    excerpt:
      "Do you end up sweating right after a long, refreshing shower? While this seems counter-productive...",
    link: "/blogdetails",
  },
];

function Blogs() {
  return (
    <>
      <div className="min-h-screen">
        <Header />
        <nav className="flex justify-center py-4 bg-gray-50">
          <ol className="flex items-center space-x-2">
            <li>
              <span className="text-gray-400 font-medium">Home</span>
            </li>
            <li>
              <span className="text-gray-300 font-medium">——</span>
            </li>
            <li>
              <span className="text-gray-700 font-medium">Blogs</span>
            </li>
          </ol>
        </nav>
        <div className="bg-white max-w-7xl mx-auto px-4 py-12">
          <div class="flex flex-col items-center text-center">
            <h1 className="text-3xl md:text-4xl text-center mb-6 secdory-font">
              Our Blog
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Our blog is your trusted source for practical advice and
              science-driven solutions. Each article is crafted by seasoned
              professionals and reviewed by specialists, ensuring you always get
              accurate, reliable information
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-8">
            {blogs.map((blog) => (
              <div key={blog.id} className="article-main">
                <div className="article_inner">
                  <div className="article-image">
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="blogs-containerimg"
                    />
                  </div>
                  <div className="article-details">
                    <div className="flex flex-col justify-between p-6 flex-1">
                      <div>
                        <p className="text-sm text-gray-400 font-medium mb-2">
                          {blog.date} |
                        </p>
                        <h2 className="font-semibold text-lg mb-2">
                          {blog.title}
                        </h2>
                        <p className="text-sm text-gray-600 mb-4">
                          {blog.excerpt}
                        </p>
                      </div>
                      <div>
                        <a
                          href={blog.link}
                          className="text-cyan-600 font-medium flex items-center gap-2 hover:underline"
                        >
                          <span className="border-cyan-600">-- Read More</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Blogs;
